import React from 'react';
interface CTAButtonProps {
  text: string;
  href?: string;
  onClick?: () => void;
  variant?: 'primary' | 'urgency';
  className?: string;
  showTrust?: boolean;
}
export function CTAButton({
  text,
  href,
  onClick,
  variant = 'primary',
  className = '',
  showTrust = true
}: CTAButtonProps) {
  const baseClasses = 'relative w-full flex flex-col items-center justify-center min-h-[64px] px-6 py-4 rounded-xl font-bold text-lg md:text-xl transition-all duration-300 overflow-hidden group';
  const primaryClasses = 'bg-forest text-gold shadow-forest hover:bg-forest-light hover:-translate-y-1 animate-pulse-soft';
  const urgencyClasses = 'bg-urgency text-white shadow-lg hover:bg-urgency-light hover:-translate-y-1 animate-pulse-urgency';
  const buttonClasses = `${baseClasses} ${variant === 'primary' ? primaryClasses : urgencyClasses} ${className}`;
  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href && href.startsWith('#')) {
      e.preventDefault();
      const target = href === '#offer-section' ? '#offer-stack' : href;
      const element = document.querySelector(target);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    onClick?.();
  };
  const isAnchorLink = href?.startsWith('#');
  const content = <>
      {/* Shine effect — pointer-events-none so it never blocks clicks */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12 pointer-events-none" data-id="element-63" data-mp="1s8k7bmnuhe4h"></div>

      <span className="relative z-10 flex items-center text-center leading-tight text-[#FBFBFA] pointer-events-none" data-id="element-64" data-mp="20zsyac7klqsx">
        {text}
      </span>
    </>;
  return <div className="w-full flex flex-col items-center" data-id="element-65" data-mp="2ay8psgaif22y">
      {href ? isAnchorLink ? <a href={href} onClick={handleAnchorClick} className={buttonClasses} data-id="element-66" data-mp="2fxcy74pm0vs8">
            {content}
          </a> : <a href={href} target="_blank" rel="noopener noreferrer" className={buttonClasses} data-id="element-67" data-mp="1qa9495m45kaf">
            {content}
          </a> : <button onClick={onClick} className={buttonClasses} data-id="element-68" data-mp="1zzsnwdhnhi6c">
          {content}
        </button>}


    </div>;
}